import styled from 'styled-components'

import theme from 'theme_'
import CommonLinkButton from 'components/Button/CommonLinkButton'
import { Font14, RegularModerate } from 'components/Typography'

export const ApplyLicenseWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`

export const ApplyLicenseButton = styled(CommonLinkButton)`
  color: ${theme.colors.horizonOrange};
  ${Font14};

  :hover {
    cursor: pointer;
    opacity: 0.8;
  }
`

export const ApplyLicenseModalContent = styled(RegularModerate)`
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const ApplyLicenseDatesWrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  margin-top: ${theme.spacing.md};
`

export const LicenseMedallionImg = styled.img`
  width: 100px;
  height: 100px;
  margin-bottom: ${theme.spacing.md};
`
